import { atom } from 'jotai';

export type IUserRole = 'admin' | 'external-analyst' | 'agent';

export interface IUser {
    username?: string;
    isAdmin?: boolean;
    roles: IUserRole[];
    email: string;
}

export const userAtom = atom<IUser | undefined>(undefined);
